<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="info"
    title="FAQ - Лимиты на личные сообщения"
    (close)="senderService.isOpenedAddBalance = true"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar" #scroll>

      <div class="container-xxl py-5">
        <div class="text-center mb-4">
        <nz-progress [nzStrokeWidth]="8" [nzFormat]="format" [nzPercent]="accountsCount$ | async"
                     [nzSuccessPercent]="accountsCount$ | async" nzType="circle"
                     [nzWidth]="130" [nzStrokeColor]="{'0%': '#108ee9', '10%': '#52c41a', '20%': '#34f52d'}"></nz-progress>
        </div>
        <p>На стороне сервиса <b>установлены лимиты</b> на отправку в <b>личные сообщения</b>, для уменьшения шансов
          блокировок аккаунтов.</p>
        <p>Количество отправляемых сообщений в сутки по всем вашим рассылкам зависит от количества имеющихся у вас аккаунтов
          Telegram, для каждого на данный момент установлено <b>10</b> сообщений.</p>
        <p>Это ограничение <b>совсем не означает</b>, что нужно создавать рассылки по 10 получателей, сама рассылка
          может быть на любое количество получателей, но <b>будет выполняться по мере</b> открытия лимитов.</p>
        <p>Также существует лимит на стороне Telegram. Если Telegram-аккаунт слишком свежий, может стоять ограничение,
          например, 2 сообщения в сутки, и 100 сообщений уже не будет. Поэтому мы <b class="pointer text-underline" (click)="addAccount()">рекомендуем покупать аккаунты у нас</b>. Мы
          стараемся следить за их качеством.</p>

        <p class="small text-muted" *ngIf="(accountsCount$ | async) > 0">
          Сейчас у вас <i>{{accountsCount$ | async}}</i>, ожидаемое количество сообщений в
          личку за сутки составляет до {{(accountsCount$ | async) * 10}}.
        </p>
        <p class="small text-muted">Сервис автоматически распределяет очередь аккаунтов при отправке, используется
          принцип очереди по последнему отправившему.</p>

      </div>
    </div>
  </div>
</div>
